import { err, ok } from 'neverthrow'
import { cidForDirItemId, cidForDirValue } from '../../../concept/cid'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'

export const DirIdFunction: HelperFunction = {
	tokenName: 'DIR_ID',
	nodeType: functionNodeTypes.DirId,
	evaluate(node, evaluateExpr) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('DIR_ID function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0])
		if (result.isErr()) return err(result.error)
		if (typeof result.value !== 'number') {
			return err(evaluatorErrorWithNode('DIR_ID function argument must be a number', node))
		}
		return ok(cidForDirItemId(result.value))
	}
}
export const DirValueIdFunction: HelperFunction = {
	tokenName: 'DIR_VALUE_ID',
	nodeType: functionNodeTypes.DirValueId,
	evaluate(node, evaluateExpr) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('DIR_VALUE_ID function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0])
		if (result.isErr()) return err(result.error)
		if (typeof result.value !== 'string') {
			return err(evaluatorErrorWithNode('DIR_VALUE_ID function argument must be a string', node))
		}
		return ok(cidForDirValue(result.value))
	}
}
